
import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Progress,
  Badge,
} from "reactstrap";

const SupervisorSummary = ({
  rooms = [],
  tasks = [],
}) => {
  const dirtyRooms = rooms.filter(
    (room) =>
      room.housekeepingStatus ===
      "DIRTY"
  ).length;

  const cleanRooms = rooms.filter(
    (room) =>
      room.housekeepingStatus ===
      "CLEAN"
  ).length;

  const occupiedRooms =
    rooms.filter(
      (room) =>
        room.occupancyStatus ===
        "OCCUPIED"
    ).length;

  const vacantReady =
    rooms.filter(
      (room) =>
        room.housekeepingStatus ===
          "CLEAN" &&
        room.occupancyStatus !==
          "OCCUPIED"
    ).length;

  const activeTasks =
    tasks.filter(
      (task) =>
        task.status ===
          "ASSIGNED" ||
        task.status ===
          "IN_PROGRESS" ||
        task.status ===
          "INSPECTION"
    );

  const completedTasks =
    tasks.filter(
      (task) =>
        task.status ===
        "COMPLETED"
    );

  const avgCleaningTime =
    completedTasks.length > 0
      ? Math.round(
          completedTasks.reduce(
            (sum, task) => {
              if (
                !task.startedAt ||
                !task.completedAt
              )
                return sum;

              return (
                sum +
                (new Date(
                  task.completedAt
                ) -
                  new Date(
                    task.startedAt
                  )) /
                  60000
              );
            },
            0
          ) /
            completedTasks.length
        )
      : 0;

  const productivity =
    tasks.length > 0
      ? Math.round(
          (completedTasks.length /
            tasks.length) *
            100
        )
      : 0;

  const remainingWorkload =
    activeTasks.length;

  const roomProgress =
    rooms.length > 0
      ? Math.round(
          (cleanRooms /
            rooms.length) *
            100
        )
      : 0;

  return (
    <Card className="mb-3 shadow-sm">
      <CardHeader className="fw-bold">
        Supervisor Summary
      </CardHeader>

      <CardBody>

        <div className="d-flex justify-content-between align-items-center mb-3">

          <div>
            <small className="text-muted">
              Overall Productivity
            </small>

            <div className="h4 mb-0">
              {productivity}%
            </div>
          </div>

          <Badge
            color={
              productivity >= 80
                ? "success"
                : productivity >=
                  50
                ? "warning"
                : "danger"
            }
          >
            {productivity >= 80
              ? "Excellent"
              : productivity >=
                50
              ? "Average"
              : "Needs Attention"}
          </Badge>

        </div>

        <Progress
          value={productivity}
          className="mb-4"
        />

        <div className="row">

          <div className="col-6 mb-3">
            <small className="text-muted">
              Total Rooms
            </small>

            <div className="fw-bold">
              {rooms.length}
            </div>
          </div>

          <div className="col-6 mb-3">
            <small className="text-muted">
              Dirty Rooms
            </small>

            <div className="fw-bold text-danger">
              {dirtyRooms}
            </div>
          </div>

          <div className="col-6 mb-3">
            <small className="text-muted">
              Clean Rooms
            </small>

            <div className="fw-bold text-success">
              {cleanRooms}
            </div>
          </div>

          <div className="col-6 mb-3">
            <small className="text-muted">
              Occupied
            </small>

            <div className="fw-bold text-primary">
              {occupiedRooms}
            </div>
          </div>

          <div className="col-6 mb-3">
            <small className="text-muted">
              Vacant Ready
            </small>

            <div className="fw-bold text-success">
              {vacantReady}
            </div>
          </div>

          <div className="col-6 mb-3">
            <small className="text-muted">
              Active Tasks
            </small>

            <div className="fw-bold text-warning">
              {activeTasks.length}
            </div>
          </div>

          <div className="col-6 mb-3">
            <small className="text-muted">
              Completed Tasks
            </small>

            <div className="fw-bold text-success">
              {
                completedTasks.length
              }
            </div>
          </div>

          <div className="col-6 mb-3">
            <small className="text-muted">
              Avg Cleaning Time
            </small>

            <div className="fw-bold">
              {avgCleaningTime} min
            </div>
          </div>

        </div>

        <hr />

        <div className="mb-2 d-flex justify-content-between">

          <span>
            Room Readiness
          </span>

          <strong>
            {roomProgress}%
          </strong>

        </div>

        <Progress
          value={roomProgress}
          className="mb-4"
        />

        <div className="d-flex justify-content-between align-items-center">

          <div>

            <small className="text-muted">
              Remaining Workload
            </small>

            <div className="h5 mb-0">
              {remainingWorkload}
            </div>

          </div>

          <Badge
            color={
              remainingWorkload >
              10
                ? "danger"
                : remainingWorkload >
                  5
                ? "warning"
                : "success"
            }
          >
            Open Tasks
          </Badge>

        </div>

      </CardBody>
    </Card>
  );
};

export default SupervisorSummary;